<template>
  <div class="page_wrapper container-fluid news_area">
    <div class="row page_header news_header">
      <news-header :news-type="currentNewsDetailsGetter.news_type_text" />
    </div>
    <div class="row news_details_content">
      <piece-news-content />
    </div>
  </div>
</template>
<script>
import NewsHeader from '~components/pages/news/NewsHeader'
import PieceNewsContent from '~components/pages/news/PieceNewsContent'
import { mapGetters } from 'vuex'
export default {
  name: 'NewsContent',
  routerName: 'News:id',
  components: {
    NewsHeader,
    PieceNewsContent
  },
  computed: {
    ...mapGetters('pages/news', [
      'currentNewsDetailsGetter'
    ])
  },
  watch: {
    '$route.params.id': {
        handler() {
        window.location.reload();
      }
    }
  },
}
</script>
